import { DEFAULT_SYSTEM_LANGUAGE } from '@/lib/constants';
import { ELocalStorageKeys } from '@/lib/enums';
import { webStorageUtil } from '@/state/webStorage.state.service';
import { getEnvVariable } from '@/lib/getEnvVariable';
import axios from 'axios';

axios.defaults.baseURL = getEnvVariable('NEXT_PUBLIC_REACT_APP_API_BASE_URL', process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL);

export default function useAxios() {
  const getCurrentLanguage = () => {
    return webStorageUtil.get(ELocalStorageKeys.CURRENT_LANGUAGE) || DEFAULT_SYSTEM_LANGUAGE;
  };

  const post = async <T = any>(
    path: string,
    { data, headers, timeout }: { data: any; headers: any; timeout?: number },
    noToken = false,
    includeLanguage = false
  ) => {
    const token = webStorageUtil.getAny(ELocalStorageKeys.SESSION_TOKEN);

    let requestData = data;
    if (includeLanguage) {
      const locale = getCurrentLanguage();
      requestData = data ? { ...data, locale } : { locale };
    }

    const response = await axios<T>({
      url: path,
      method: 'POST',
      headers: {
        ...headers,
        Authorization: !noToken ? `Bearer ${token}` : undefined
      },
      data: requestData,
      timeout,
    });

    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  };

  const get: (
    path: string,
    noToken?: boolean,
    params?: any,
    headers?: any,
    includeLanguage?: boolean
  ) => Promise<any> = async (
    path,
    noToken = false,
    params,
    headers = {},
    includeLanguage = false
  ) => {
      const token = webStorageUtil.getAny(ELocalStorageKeys.SESSION_TOKEN);

      let finalParams = params;
      if (includeLanguage) {
        const locale = getCurrentLanguage();
        const languageParams = { locale };
        finalParams = params ? { ...params, ...languageParams } : languageParams;
      }

      const response = await axios({
        url: path,
        method: 'GET',
        headers: {
          ...headers,
          Authorization: !noToken ? `Bearer ${token}` : undefined,
          'x-session-id': !noToken ? token : undefined
        },
        params: finalParams || undefined
      });

      return response.data;
    };

  return { post, get };
}
